export function numberToString(num: number | undefined | null, maxDec: number = 2): string {
    if (num != undefined) {
        return num.toLocaleString(undefined, { minimumFractionDigits: 2 , maximumFractionDigits: maxDec, useGrouping:true});
    }
    return "";
}
